<template>
  <bg-style class="store-v3-item" :class="{ 'is-mobile': $store.getters.isMobile }" :bg="active ? model.activeCardBackground : model.cardBackground">
    <im-image v-if="isHasCorner" :src="good.corner" class="corner-logo" />
    <div class="thumb relative">
      <img v-if="good.icon" class="object-contain" :src="good.icon" alt="">
    </div>
    <div class="flex items-center justify-center relative content">
      <template v-if="good.item_contents?.[0]">
        <img :src="good.item_contents?.[0]?.icon" alt="">
        <i class="el-icon-close" />
        <span>{{ good.item_contents?.[0]?.num }}</span>
      </template>
    </div>
    <div class="flex items-center gifts relative justify-center">
      <template v-if="good.gift_list?.[0]">
        <span>{{ $t('siteBuild.extraGift') }}</span>
        <img class="ml-1" :src="good.gift_list?.[0]?.gift_goods_logo" alt="">
        <i class="el-icon-close" />
        <span class="number">{{ good.gift_list?.[0]?.num }}</span>
      </template>
    </div>
    <div class="price relative text-center">
      <div v-if="isShowCountdown" class="flex items-center justify-center">
        <i class="el-icon-time mr-1" />
        <template v-if="countdownDays === '00' && countdownHours !== '00'">
          <span>{{ countdownHours }}h:{{ countdownMinutes }}m</span>
        </template>
        <template v-if="countdownDays !== '00'">
          <span>{{ countdownDays }}d:{{ countdownHours }}h</span>
        </template>
        <template v-if="countdownDays === '00' && countdownHours === '00'">
          <span>{{ countdownMinutes }}m:{{ countdownSeconds }}s</span>
        </template>
      </div>
      <template v-else>
        <span>{{ labelPriceText }}</span>
        <span v-if="isShowOriginalPrice" class="line-through original">{{ originalLabelPriceText }}</span>
      </template>
    </div>
  </bg-style>
</template>

<script>
import GoodsMixin from '../storeWidget/oneGood/goodMixins'
export default {
  mixins: [GoodsMixin],
  props: {
    model: Object,
    active: Boolean
  }
}
</script>

<style lang="less">
.store-v3-item {
  width: 240px;
  height: 240px;
  cursor: pointer;
  flex-shrink: 0;
  padding-top: 38px;
  position: relative;
  .corner-logo {
    position: absolute;
    width: 35%;
    height: 35%;
    top: -20px;
    left: -8px;
  }
  .thumb {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 98px;
    img {
      max-height: 100px;
      max-width: 180px;
    }
  }
  .content {
    font-size: 16px;
    color: var(--text-color);
    margin-top: 6px;
    height: 30px;
    font-weight: bold;
    i {
      font-weight: bold;
    }
    img {
      max-width: 30px;
    }
  }
  .gifts {
    color: var(--text-color);
    font-size: 14px;
    height: 21px;
    font-weight: bold;
    i {
      font-weight: bold;
    }
    img {
      width: 15px;
    }
    .number,.el-icon-close {
      font-size: 12px;
    }
  }
  .price {
    font-weight: bold;
    font-size: 20px;
    color: var(--price-color);
    margin-top: 5px;
    .original {
      font-size: 12px;
      margin-left: 5px;
    }
  }
  &.is-mobile {
    width: 164px;
    height: 164px;
    padding-top: 16px;
    padding-bottom: 2px;
    .corner-logo {
      width: 30%;
      height: 30%;
      top: -10px;
      left: -5px;
    }
    .thumb {
      height: 80px;
      img {
        max-height: 100px;
        max-width: 100px;
      }
    }
    .content {
      height: 21px;
      font-size: 14px;
      margin-top: 0;
      top: 2px;
      img {
        width: 18px;
      }
    }
    .gifts {
      font-size: 12px;
      margin-top: 0;
      height: 18px;
    }
    .price {
      margin-top: 0;
      font-size: 16px;
      position: relative;
      top: -2px;
    }
  }
}
</style>
